export const FETCH_ACTIVITIES_REQUEST = 'FETCH_ACTIVITIES_REQUEST';
export const FETCH_ACTIVITIES_SUCCESS = 'FETCH_ACTIVITIES_SUCCESS';
export const FETCH_ACTIVITIES_FAIL = 'FETCH_ACTIVITIES_FAIL';

export const FETCH_SCHEDULES_REQUEST = 'FETCH_SCHEDULES_REQUEST';
export const FETCH_SCHEDULES_SUCCESS = 'FETCH_SCHEDULES_SUCCESS';
export const FETCH_SCHEDULES_FAIL = 'FETCH_SCHEDULES_FAIL';

export const FETCH_USER_SCHEDULES_REQUEST = 'FETCH_USER_SCHEDULES_REQUEST';
export const FETCH_USER_SCHEDULES_SUCCESS = 'FETCH_USER_SCHEDULES_SUCCESS';
export const FETCH_USER_SCHEDULES_FAIL = 'FETCH_USER_SCHEDULES_FAIL';

export const CREATE_USER_SCHEDULE_REQUEST = 'CREATE_USER_SCHEDULE_REQUEST';
export const CREATE_USER_SCHEDULE_SUCCESS = 'CREATE_USER_SCHEDULE_SUCCESS';
export const CREATE_USER_SCHEDULE_FAIL = 'CREATE_USER_SCHEDULE_FAIL';

export const DESTROY_USER_SCHEDULE_REQUEST = 'DESTROY_USER_SCHEDULE_REQUEST';
export const DESTROY_USER_SCHEDULE_SUCCESS = 'DESTROY_USER_SCHEDULE_SUCCESS';
export const DESTROY_USER_SCHEDULE_FAIL = 'DESTROY_USER_SCHEDULE_FAIL';

export const USER_SIGN_IN_REQUEST = 'USER_SIGN_IN_REQUEST';
export const USER_SIGN_IN_SUCCESS = 'USER_SIGN_IN_SUCCESS';
export const USER_SIGN_IN_FAIL = 'USER_SIGN_IN_FAIL';

export const USER_SIGN_UP_REQUEST = 'USER_SIGN_UP_REQUEST';
export const USER_SIGN_UP_SUCCESS = 'USER_SIGN_UP_SUCCESS';
export const USER_SIGN_UP_FAIL = 'USER_SIGN_UP_FAIL';

export const USER_SIGN_OUT_REQUEST = 'USER_SIGN_OUT_REQUEST';
export const USER_SIGN_OUT_SUCCESS = 'USER_SIGN_OUT_SUCCESS';
export const USER_SIGN_OUT_FAIL = 'USER_SIGN_OUT_FAIL';

export const IS_LOGGED_IN = 'IS_LOGGED_IN';
